export default "__VITE_ASSET__06bd0480__"